function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7771 14C19.8677 18.008 16.2833 21 12.0002 21C7.71698 21 4.13263 18.008 3.22318 14H2.2002C3.12674 18.5645 7.16224 22 12.0002 22C16.8381 22 20.8736 18.5645 21.8001 14H20.7771ZM3.22318 10C4.13263 5.99202 7.71698 3 12.0002 3C16.2833 3 19.8677 5.99202 20.7771 10H21.8001C20.8736 5.43552 16.8381 2 12.0002 2C7.16224 2 3.12674 5.43552 2.2002 10H3.22318Z",
  fill: "#00ACA0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 8.5L21.5 10L22 7",
  stroke: "#00ACA0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 15.5L2.5 14L2 17",
  stroke: "#00ACA0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 10,
  width: 6,
  height: 5,
  rx: 0.5,
  stroke: "#00ACA0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 9.5V9C10.5 8.17157 11.1716 7.5 12 7.5V7.5C12.8284 7.5 13.5 8.17157 13.5 9V9.5",
  stroke: "#00ACA0"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5,
  r: 0.5,
  stroke: "#00ACA0"
});

var SvgChangePass = function SvgChangePass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangePass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change_pass.cd98aa3d.svg";
export { ForwardRef as ReactComponent };